import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormikContextType, useFormikContext } from 'formik';
import { Card } from 'react-bootstrap';
import { capitalize, get, isEqual, upperFirst } from 'lodash';
import classNames from 'classnames';

import { Trip } from 'entities/Trip';
import { MaskInput } from 'modules/shared/Forms';
import VerifyPhone from 'modules/common/VerifyPhoneBtn';
import { Document } from 'entities/Document/interfaces';
import { peripheralsSelector } from 'modules/common/Header/selectors';
import { faceIDSelector } from 'modules/security/containers/TripContainer/services/selectors';
import { getDrIdReguest } from 'modules/security/containers/TripContainer/services/actions';
import { useModal } from 'modules/shared/hooks';
import { IVisitorWithTransport } from 'entities/Visitor/interfaces';
import TopBorderBtn from 'modules/shared/TopBorderBtn';
import { logoutSelector } from 'modules/common/LogoutBtn/selectors';
import { tripLoadedReqDataSelector } from 'modules/common/FillTrip';
import CardImage from '../CardImage';
import styles from './VisitorCard.module.scss';

type Props = {
  type: 'driver' | 'forwarder';
  handleChange: any;
  onClick: any;
  onDeleteField: (type: any) => void;
  className?: string;
};

const VisitorCard: React.FC<Props> = ({ type, handleChange, onClick, onDeleteField, className = '' }) => {
  const dispatch = useDispatch();
  const isDriver = isEqual(type, 'driver');
  const title = isDriver ? 'Водій' : 'Експедитор';

  const { errorFaceID } = useSelector(faceIDSelector);
  const peripherals = useSelector(peripheralsSelector);
  const { loaded } = useSelector(tripLoadedReqDataSelector);

  const { branchTitle } = useSelector(logoutSelector);

  const [errReqData, setErrReqData] = useState('');
  const { isShow, openModal, closeModal } = useModal();
  const faceIdUrl = peripherals?.find((p: any) => p.type === 'FaceID')?.peripheralUrl;

  const formik: FormikContextType<Trip> = useFormikContext();
  const { values } = formik;

  // @ts-ignore
  const currentState: IVisitorWithTransport = get(values, type);

  const { firstName, lastName, middleName, phone } = currentState;
  const documents: Document[] = get(values[type], 'documents', []);
  const isNumberPhoneValid = get(values, `is${upperFirst(type)}PhoneNumberValid`, false);
  const validatePhone =
    phone && !!phone.number?.length && (lastName || firstName) && branchTitle && branchTitle?.sendPhoneVerification;

  const doumentType1 = documents.find((doc: any) => isEqual(doc.type, 1)) || {
    number: '',
    pictures: [],
  };
  const doumentType3 = documents.find((doc: any) => isEqual(doc.type, 3)) || {
    number: '',
    pictures: [],
  };

  const onFaceIdVisitor = () => {
    if (faceIdUrl) {
      dispatch(getDrIdReguest(faceIdUrl, type, values));
    }
  };

  useEffect(() => {
    if (errorFaceID) {
      onDeleteField(type);
      return openModal();
    }
    closeModal();
  }, [errorFaceID]);

  useEffect(() => {
    if (loaded?.isError) {
      onDeleteField(type);
      setErrReqData(loaded?.type);
      openModal();

      setTimeout(() => {
        setErrReqData('');
        closeModal();
      }, 3000);
    }
  }, [loaded?.isError]);

  return (
    <div className={classNames(styles.driver_card, className)}>
      <Card>
        <div className={styles.cardTitle}>
          <div className="d-flex flex-row">
            <h3 className="font-weight-bold ml-3">{title}</h3>
            {/* {isShow && isEqual(type, fieldFaceID) ? (
              <h3 className="text-danger ml-4">{errorFaceID?.message || 'Помилка при отриманні данних'}</h3>
            ) : null} */}

            {isShow && errorFaceID?.message && (
              <h3 className="text-danger ml-4">{errorFaceID?.message || 'Помилка при отриманні данних'}</h3>
            )}

            {isShow && isEqual(type, errReqData.split('.')[0]) ? (
              <h3 className="text-danger ml-4">не знайдено</h3>
            ) : null}
          </div>
          <div className="d-flex flex-row align-items-center">
            {middleName || firstName || lastName ? (
              <TopBorderBtn
                icon="delete"
                clickHandler={() => {
                  onDeleteField(type);
                }}
              />
            ) : null}
          </div>

          <div className={styles.faceOverlayBtn}>
            <TopBorderBtn icon="face" clickHandler={onFaceIdVisitor} />
          </div>
        </div>

        <Card.Text className="p-0 m-0 d-flex flex-row">
          <MaskInput
            name={`${type}.phone.number`}
            label="Телефон"
            placeholder="38 (0__) ___-__-__"
            onChange={handleChange}
            onClick={onClick}
            value={phone?.number}
          >
            {validatePhone ? (
              <div className="d-flex flex-row align-items-center">
                <VerifyPhone
                  mode="kiosk"
                  value={phone?.number.replace(/\D/g, '')}
                  inputVerifyField={`is${capitalize(type)}PhoneNumberValid`}
                />
                <small className={`ml-5 pl-3 text-center ${isNumberPhoneValid ? 'text-success' : 'text-danger'}`}>
                  Номер {!isNumberPhoneValid && 'не'} верифіковано
                </small>
              </div>
            ) : null}
          </MaskInput>
        </Card.Text>

        <Card.Text>
          {lastName} {firstName} {middleName}
        </Card.Text>

        {doumentType1?.number?.length ? <Card.Text>Права: {doumentType1?.number}</Card.Text> : null}
        {doumentType3?.number?.length ? <Card.Text>Паспорт: {doumentType3?.number}</Card.Text> : null}
      </Card>
      <div className="d-flex justify-content-around">
        {firstName || middleName || lastName ? <CardImage type={type} /> : null}
      </div>
    </div>
  );
};

export default VisitorCard;
